import './style.css';

export function email_dialog(email) {        
    return new Promise(resolve => {
        let dlg = new Graphite.ModalDialog({
            id:"email-dialog",
            width: 640,
            padding: '40px 40px 30px',
            close_when_click_outside: false,
            close_with_esc: false
        })

        dlg.email = email;

        dlg.on('before-open', () => {
            dlg.popup.querySelector('[name="subject"]').focus();
        })

        dlg.popup.on('click', evt => {
            let el = evt.target;

            if (el.matches('[data-role="button"][data-cmd="send"]')) {
                let data = {
                    subject: dlg.popup.querySelector('[name="subject"]').value.trim(),
                    description: dlg.popup.querySelector('[name="description"]').value.trim(),
                    name: dlg.popup.querySelector('[name="name"]').value.trim(),
                    contact_no: dlg.popup.querySelector('[name="contact_no"]').value.trim()
                }

                let msg;

                if (!data.subject) {
                    msg = 'กรุณาระบุเรื่องที่ต้องการสอบถามด้วย' + Graphite.get_ending();

                    if (Graphite.config.default_language != 'th') {
                        msg = 'Please tell us the question you want to ask!';
                    }

                    Graphite.show_message(msg).then(() => {
                        dlg.popup.querySelector('[name="subject"]').focus();   
                    })
                
                    return;
                }

                if (!data.description) {
                    msg = 'กรุณาระบุรายละเอียดที่การสอบถามด้วย' + Graphite.get_ending();

                    if (Graphite.config.default_language != 'th') {
                        msg = 'Please give us some detail about your question!';
                    }

                    Graphite.show_message(msg).then(() => {
                        dlg.popup.querySelector('[name="description"]').focus();   
                    })
                
                    return;
                }

                if (!data.name) {
                    msg = 'กรุณาระบุ ชื่อ นามสกุล ด้วย' + Graphite.get_ending();

                    if (Graphite.config.default_language != 'th') {
                        msg = 'Please tell us your name!';
                    }

                    Graphite.show_message(msg).then(() => {
                        dlg.popup.querySelector('[name="name"]').focus();   
                    })
                
                    return;
                }

                if (!data.contact_no) {
                    msg = 'กรุณาระบุเบอร์โทรด้วย' + Graphite.get_ending();

                    if (Graphite.config.default_language != 'th') {
                        msg = 'Please tell us your contact number!';
                    }

                    Graphite.show_message(msg).then(() => {
                        dlg.popup.querySelector('[name="contact_no"]').focus();   
                    })
                
                    return;
                }

                let node = {
                    sender_email: 'noreply@' + Graphite.config.domain,
                    sender_name: data.name,
                    recipient_email: email,
                    recipient_name: email,
                    subject: data.subject,
                    body: data.description + ' จากคุณ "' + data.name + '" เบอร์โทร.' + data.contact_no                         
                }

                let loading_dlg = Graphite.show_loading('กำลังส่ง E-mail', {
                    src: './images/moodeng.png',
                    width: 209,
                    height: 172,
                    frames: 20,
                    duration: '1.75s'                    
                })

                Graphite.send_mail(node).then(res => {
                    loading_dlg.close();

                    if (res.status == 200) {                        
                        dlg.set_cmd('send');
                        dlg.set_value(true);
                        dlg.close();

                        setTimeout(() => {
                            msg = 'ขอบคุณสำหรับข้อความ ระหว่างนี้กรุณารอการติดต่อกลับจากทีมงานของเรานะ' + Graphite.get_ending();

                            if (Graphite.config.default_language != 'th') {
                                msg = 'Thank you for your information. We will contact you very soon!';
                            }

                            Graphite.show_message(msg);                            
                        }, 400)
                    } else {
                        setTimeout(() => {
                            msg = 'ไม่สามารถส่ง E-mail ได้ในขณะนี้ กรุณาติดต่อ Admin เพื่อรับความช่วยเหลือ';

                            if (Graphite.config.default_language != 'th') {
                                msg = 'We can\' send E-mail right now, please contact our Admin for help!';
                            }

                            Graphite.show_message(msg);
                        }, 400)
                    }
                })
            }
        })

        let url = Graphite.config.www_root + 'system/dialogs/email-dialog.php';

        Graphite.get_html(url).then(html => {
            dlg.html(html)        
            
            let el = dlg.popup.querySelector('input[name="contact_no"]');

            el.on('keydown', evt => {
                if (evt.keyCode == 13) {
                    dlg.popup.querySelector('button[data-cmd="send"]').click();
                }
            })

            Graphite.create_tel_input(el);
            resolve(dlg.open());
        })
    })
}
